import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=8bd18ba6&scoped=true"
import script from "./overview.vue?vue&type=script&setup=true&lang=js"
export * from "./overview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./overview.vue?vue&type=style&index=0&id=8bd18ba6&prod&scoped=true&lang=css"
import style1 from "./overview.vue?vue&type=style&index=1&id=8bd18ba6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd18ba6",
  null
  
)

export default component.exports